import Anchor from './anchors';

// To start with we look for all headings with span[lang], this is for lingual headings
let jumpLinksSelector = '.page-content h2:not([data-ignore]):not(.h2) span[lang]';

let jumpLinkElements = document.querySelectorAll(jumpLinksSelector);

// When there are no bi-lingual headings, look for all other headings
if (jumpLinkElements.length === 0) {
    jumpLinksSelector = '.page-content h2:not([data-ignore]):not(.h2)';
    jumpLinkElements = document.querySelectorAll(jumpLinksSelector);
}

const jumpLinksCount = jumpLinkElements.length;

if (jumpLinksCount > 2) {
    new Anchor(jumpLinksSelector); // eslint-disable-line
} else if (document.querySelector(".jumplink-block")) {
    document.querySelector(".jumplink-block").style.display = "none";
}
